export default __webpack_public_path__ + "assets/323e4557760f7ee0a28a08cfd12fcb3a.png";